import { Button, styled } from '@tools/wr-catalog-base'

export const StyledExportButton = styled(Button)`
  padding-top: 14px;
  padding-bottom: 14px;
`
